import React from 'react';

const FAPreferredOffice = () => {
  return (
    <svg width="250" height="120" viewBox="0 0 250 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M136 25a7 7 0 1 1 0 14h64a7 7 0 1 1 0 14h22a7 7 0 1 1 0 14h-19a7 7 0 1 0 0 14h6a7 7 0 1 1 0 14h-52a7 7 0 0 1-1.5-.161A7 7 0 0 1 154 95H63a7 7 0 1 1 0-14H24a7 7 0 1 1 0-14h40a7 7 0 1 0 0-14H39a7 7 0 1 1 0-14h40a7 7 0 1 1 0-14zm90 56a7 7 0 1 1 0 14 7 7 0 0 1 0-14"
        fill="#eceff1"
      />
      <path
        d="m163.673 34.463-83.68 7.321a2 2 0 0 0-1.819 2.167l5.317 60.768a2 2 0 0 0 2.166 1.818l83.681-7.321a2 2 0 0 0 1.818-2.167l-5.317-60.768a2 2 0 0 0-2.166-1.818Z"
        fill="#fff"
        stroke="#90a4ae"
      />
      <path
        d="m147.221 96.638-56.975 4.98A2 2 0 0 1 88.08 99.8l-4.188-47.839c15.952 20.672 37.942 36.445 63.329 44.677"
        fill="#eceff1"
      />
      <path
        d="M118.859 50.699c10.67-2.86 21.636 3.472 24.495 14.142s-3.473 21.636-14.142 24.495c-10.669 2.858-21.636-3.473-24.495-14.143-2.859-10.669 3.473-21.636 14.142-24.494m15.386 8.406-14.017 24.28c2.39.65 4.978.696 7.544.008 7.735-2.072 12.325-10.023 10.253-17.758a14.44 14.44 0 0 0-3.78-6.53m-13.979-3.723c-7.736 2.072-12.326 10.023-10.253 17.759a14.44 14.44 0 0 0 3.761 6.512l14.013-24.27a14.43 14.43 0 0 0-7.521-.001"
        fill="#eceff1"
      />
      <path
        d="M135.244 59.363 120.742 84.48c2.473.673 5.151.72 7.805.009 8.002-2.144 12.751-10.37 10.607-18.371a14.9 14.9 0 0 0-3.91-6.755Zm-14.461-3.852c-8.002 2.144-12.751 10.37-10.607 18.371a14.94 14.94 0 0 0 3.68 6.523l14.416-24.967a14.9 14.9 0 0 0-7.489.073Z"
        stroke="#90a4ae"
      />
      <path
        d="M135.019 50.589a22 22 0 0 1 3.658 2.448m2.531 2.452a21.9 21.9 0 0 1 4.707 8.817c3.145 11.736-3.82 23.8-15.556 26.944-11.736 3.145-23.8-3.82-26.944-15.556-3.145-11.736 3.82-23.8 15.556-26.944a21.9 21.9 0 0 1 12.347.277"
        stroke="#90a4ae"
      />
      <path d="M125.661 7.332a5.5 5.5 0 1 1-8.992 0 4.5 4.5 0 1 0 8.996.168z" fill="#eceff1" />
      <path d="m86.859 35.741 3.618-3.23m2.635-2.354L116.68 9.11m11.637 2.824 28.931 17.648" stroke="#b0bec5" />
      <path d="M121.165 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z" stroke="#90a4ae" />
    </svg>
  );
};

export default FAPreferredOffice;
